const formatterAvatar = function(avatar) {
    if (avatar) {
        if (avatar.indexOf("data:image/png;base64") >= 0) {
            return avatar
        } else if (avatar.indexOf("http") < 0) {
            if (avatar.indexOf("upload") > -1) {
                avatar = "http://cdn.wecarepet.com/" + avatar
            } else {
                avatar = "http://cdn.wecarepet.com/upload/" + avatar
            }
            return avatar
        } else {
            return avatar
        }
    } else {
        return ""
    }
}

const getAge = function(dateTime, today) {
    if (today == null) today = new Date()
    var birthDate = new Date(dateTime)
    var age = today.getFullYear() - birthDate.getFullYear()
    var m = today.getMonth() - birthDate.getMonth()
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--
        m = 12 + m
    }
    if (m === 1 && today.getDate() < birthDate.getDate()) m = 0
    if (age < 0) return "还未出生"
    return age + "岁" + m + "个月"
}

const gettimeago = function(period) {
    // eslint-disable-next-line valid-typeof
    if (typeof period === "String") {
        period = period.replace(/-/g, "/")
    }
    var yearLevelValue = 365 * 24 * 60 * 60 * 1000
    var monthLevelValue = 30 * 24 * 60 * 60 * 1000
    var dayLevelValue = 24 * 60 * 60 * 1000
    var hourLevelValue = 60 * 60 * 1000
    var minuteLevelValue = 60 * 1000
    var secondLevelValue = 1000

    function getDifference(period) {
        var year = parseInt(getYear(period))
        var month = parseInt(getMonth(period - year * yearLevelValue))
        var day = parseInt(
            getDay(period - year * yearLevelValue - month * monthLevelValue)
        )
        var hour = parseInt(
            getHour(
                period -
                year * yearLevelValue -
                month * monthLevelValue -
                day * dayLevelValue
            )
        )
        var minute = parseInt(
            getMinute(
                period -
                year * yearLevelValue -
                month * monthLevelValue -
                day * dayLevelValue -
                hour * hourLevelValue
            )
        )
        //   var second = parseInt(getSecond(period - year * yearLevelValue - month * monthLevelValue - day * dayLevelValue - hour * hourLevelValue - minute * minuteLevelValue))
        var result = ""
        if (year != 0) result = result + year + "年"
        if (month != 0) result = result + month + "月"
        if (day != 0) result = result + day + "天"
        if (hour != 0) result = result + hour + "小时"
        if (minute != 0) result = result + minute + "分"
        //  if (second != 0) result = result + second + "秒"
        function getYear(period) {
            return Math.floor(parseInt(period) / yearLevelValue)
        }
        function getMonth(period) {
            return Math.floor(parseInt(period) / monthLevelValue)
        }
        function getDay(period) {
            return Math.floor(parseInt(period) / dayLevelValue)
        }
        function getHour(period) {
            return Math.floor(parseInt(period) / hourLevelValue)
        }
        function getMinute(period) {
            return Math.floor(parseInt(period) / minuteLevelValue)
        }
        return result
    }
    return getDifference(new Date(period).getTime() - new Date().getTime())
}

const dateFormate = function(dateStr, fmt) {
    // 时间戳转为时间格式
    var date = new Date(dateStr)
    // 处理年份
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(
            RegExp.$1,
            (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        )
    }
    var o = {
        "M+": date.getMonth() + 1, // 月份
        "d+": date.getDate(), // 天
        "h+": date.getHours(), // 小时
        "m+": date.getMinutes(), // 分钟
        "s+": date.getSeconds() // 秒
    }
    for (let k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
            let str = o[k] + ""
            fmt = fmt.replace(
                RegExp.$1,
                RegExp.$1.length === 1 ? str : ("00" + str).substr(str.length)
            )
        }
    }
    return fmt
}

const getLocalTime = function(time, i) {
    // 参数i为时区值数字，比如北京为东八区则输进8,西5输入-5
    if (typeof i !== "number") return
    var d = new Date(time)
    // 得到1970年一月一日到现在的秒数
    var len = d.getTime()
    // 本地时间与GMT时间的时间偏移差
    var offset = d.getTimezoneOffset() * 60000
    // 得到现在的格林尼治时间
    var utcTime = len + offset
    return new Date(utcTime + 3600000 * i).getTime()
}

const querytypefilter = function(queryTypeArr) {
    var queryTypes = []
    if (queryTypeArr instanceof Array) {
        queryTypeArr.map(queryType => {
            switch (queryType) {
            case "Action":
                queryTypes.push("行为类")
                break
            case "Disease":
                queryTypes.push("疾病类")
                break
            case "Conservation":
                queryTypes.push("日常养护")
                break
            case "SecondOpinion":
                queryTypes.push("去过医院")
                break
            }
        })
        return queryTypes.join("、")
    } else {
        switch (queryTypeArr) {
        case "Action":
            queryTypes.push("行为类")
            break
        case "Disease":
            queryTypes.push("疾病类")
            break
        case "Conservation":
            queryTypes.push("日常养护")
            break
        case "SecondOpinion":
            queryTypes.push("去过医院")
            break
        }
    }
}

const getName = function(value) {
    let nameList = [
        { name: "Normal", value: "正常" },
        { name: "Poor", value: "食欲差" },
        { name: "NoAppetite", value: "不进食" },
        { name: "BAR", value: "正常" },
        { name: "Obtunded", value: "低迷" },
        { name: "Depressed", value: "反应迟钝" },
        { name: "QAR", value: "安静" },
        { name: "Comatose", value: "昏迷" },
        { name: "Dry", value: "干燥" },
        { name: "Soft", value: "软便" },
        { name: "Diarrhea", value: "拉稀" },
        { name: "Constipated", value: "便秘" },
        { name: "High", value: "频率高" },
        { name: "Low", value: "频率低" },
        { name: "Homemade", value: "自制粮" },
        { name: "Commercial", value: "商业粮" }
    ]
    let result = ""
    nameList.map(item => {
        if (item.name == value) {
            result = item.value
        }
    })
    return result
}
const relativeDate = function(timestamp) {
    var minutesPassed = Math.floor(
        (Date.parse(new Date()) - timestamp) / 1000 / 60
    )
    if (minutesPassed <= 0) {
        return '刚刚'
    } else if (minutesPassed < 60) {
        return minutesPassed + '分钟前'
    } else if (minutesPassed < 60 * 24) {
        return Math.floor(minutesPassed / 60) + '小时前'
    } else if (minutesPassed < 60 * 24 * 2) {
        return Math.floor(minutesPassed / 60 / 24) + '天前'
    } else if (minutesPassed > 60 * 24 * 2) {
        var date = new Date(timestamp)
        var month = date.getMonth() + 1
        var day = date.getDate()
        return month + '月' + day + '日'
        // return getDate(timestamp);
    }
}

export default {
    getAge,
    gettimeago,
    getLocalTime,
    dateFormate,
    querytypefilter,
    getName,
    formatterAvatar,
    relativeDate
}



// WEBPACK FOOTER //
// ./src/common/js/filter.js